import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {SocialRoute} from "./social.route";
import {MatPaginatorModule} from "@angular/material/paginator";
import {UtilityModule} from "../utility/utility.module";
import {NotificationComponent} from "./notifications/components/notification/notification.component";
import {MatCardModule} from "@angular/material/card";
import {
  StickyNotificationsComponent
} from './notifications/components/sticky-notifications/sticky-notifications.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CKEditorModule} from "@ckeditor/ckeditor5-angular";

@NgModule({
  declarations: [
    NotificationComponent,
    StickyNotificationsComponent
  ],
  imports: [
    CommonModule,
    SocialRoute,
    MatPaginatorModule,
    UtilityModule,
    MatCardModule,
    NgOptimizedImage,
    FormsModule,
    CKEditorModule,
    ReactiveFormsModule
  ],
    exports: [
        NotificationComponent,
        StickyNotificationsComponent
    ],
})
export class SocialModule { }
